module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "autocomplete-input",
    class: _vm.styling
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    ref: "searchinput",
    staticClass: "input",
    attrs: {
      "placeholder": _vm.searchPlaceholder,
      "autofocus": _vm.autoFocus
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "focus": _vm.searchFocus,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }, function($event) {
        return _vm.onInput($event.target.value)
      }],
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        _vm.isOpen = false
      },
      "blur": _vm.searchBlur,
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        return _vm.moveDown.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        return _vm.moveUp.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.select.apply(null, arguments)
      }]
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "options-list"
  }, [_vm._l((_vm.fOptions), function(option, index) {
    return _c('li', {
      class: {
        'highlighted': index === _vm.highlightedPosition
      },
      on: {
        "mouseenter": function($event) {
          _vm.highlightedPosition = index
        },
        "mousedown": _vm.select
      }
    }, [_vm._t("item", function() {
      return [_c('article', {
        staticClass: "media"
      }, [(option.name && !option.properties) ? _c('p', [_c('strong', [_vm._v(_vm._s(option.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(option.category) + " (" + _vm._s(option.plcount) + ")")])]) : _vm._e(), _vm._v(" "), (option.plno && option.photos) ? _c('p', [_c('strong', [_vm._v(_vm._s(option.reneeid))]), _vm._v(" "), _c('span', [_vm._v("Location")])]) : _vm._e(), _vm._v(" "), (option.name && option.properties) ? _c('p', [_c('strong', [_vm._v(_vm._s(option.name))]), _vm._v(" "), _c('span', [_vm._v("Building")])]) : _vm._e(), _vm._v(" "), (option.address && !option.tags) ? _c('p', [_c('strong', [_vm._v(_vm._s(option.address))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(option.reneeid))])]) : _vm._e()])]
    }, {
      "title": option.title,
      "description": option.description,
      "thumbnail": option.thumbnail
    })], 2)
  }), _vm._v(" "), (!_vm.fOptions) ? _c('li', [_vm._m(0)]) : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "media"
  }, [_c('p', [_c('strong', [_vm._v("No Results")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-267544e6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Autocomplete.vue
// module id = 201
// module chunks = 1